import { render, staticRenderFns } from "./WritePageDisable.vue?vue&type=template&id=1c1418e3&scoped=true&"
import script from "./WritePageDisable.vue?vue&type=script&lang=js&"
export * from "./WritePageDisable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1418e3",
  null
  
)

export default component.exports